<template>
    <div id="mycanvas" ref="mycanvas">
      <div id="mycanvas-controls">
        <v-btn v-if="selectedAnimation" @click="resizeToggle">{{ transformControlMode }}</v-btn>
        <!-- <v-btn @click="resize"></v-btn> -->
      </div>

    </div>
</template>

<script>
import * as Three from 'three'
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js'
// import { ColladaLoader } from 'three/examples/jsm/loaders/ColladaLoader.js'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { assetModelStorageRef, assetPropStorageRef } from '../../firebaseDB'
import * as NodeCache from 'node-cache'
Three.Cache.enabled = true

// radianUnit is used to convert radians to degrees
const radianUnit = 57.2958

// unity offset
const positionOffset = 900
export default {
  props: ['editor', 'animationSelected', 'selectedTimeline', 'currentNode'],
  data () {
    return {
      camera: null,
      scene: null,
      selectedModel: null,
      renderer: null,
      mesh: null,
      loader: null,
      controls: null,
      transformControl: null,
      transformControlMode: 'translate',
      grid: null,
      raycaster: null,
      mouse: null,
      model: null,
      hemiLight: null,
      directLight: null,
      mixers: [],
      clock: new Three.Clock(),
      selectedAnimation: null,
      id: null,
      modelUrlCache: new NodeCache({useClones: false})
    }
  },
  watch: {
    // selectedAnimation (selected) {
    //   if (this.selectedAnimation && (this.selectedAnimation.type === 'Character' || this.selectedAnimation.type === 'Prop') && this.selectedAnimation.phase === 'assetSelected') {
    //     if (this.selectedModel) {
    //       this.transformControl.detach(this.model)
    //     }
    //     let selectedModel = this.scene.children.find(child => child.name === this.selectedAnimation.name)
    //     this.selectedModel = selectedModel
    //     this.transformControl.attach(this.selectedModel)
    //   } else {
    //     this.transformControl.detach(this.selectedModel)
    //   }
    // }
    currentNode () {
      this.transformControl.detach(this.model)
    }
  },
  methods: {
    selectAnimation (selected) {
      this.selectedAnimation = selected
      if (this.selectedAnimation && (this.selectedAnimation.type === 'Character' || this.selectedAnimation.type === 'Prop') && this.selectedAnimation.phase === 'assetSelected') {
        if (this.selectedModel) {
          this.transformControl.detach(this.selectedModel)
        }
        let selectedModel = this.scene.children.find(child => child.name === this.selectedAnimation.id)
        this.selectedModel = selectedModel
        this.transformControl.attach(this.selectedModel)
        this.controls.enabled = false
      } else {
        this.transformControl.detach(this.selectedModel)
        this.controls.enabled = true
      }
    },
    getOriginalModelById (modelId) {
      console.log(modelId)
      return assetModelStorageRef.child(`${modelId}/original.fbx`).getDownloadURL()
    },
    getModelAnimationById (animationId) {
      return assetModelStorageRef.child(`animations/${animationId}/original.fbx`).getDownloadURL()
    },
    getPropById (propId) {
      return assetPropStorageRef.child(`${propId}.fbx`).getDownloadURL()
    },
    keyDownEvent (e) {
      if (e.keyCode === 87) {
        // W key is pressed
        this.transformControl.setMode('translate')
      } else if (e.keyCode === 69) {
        // E key is pressed
        this.transformControl.setMode('rotate')
      } else if (e.keyCode === 79) {
        // O key is pressed
        this.controls.enabled = !this.controls.enabled
      }
    },
    resizeToggle () {
      this.transformControlMode = this.transformControlMode === 'translate' ? 'rotate' : 'translate'
      this.transformControl.setMode(this.transformControlMode)
    },
    init: function () {
      let container = this.$refs.mycanvas

      this.renderer = new Three.WebGLRenderer({antialias: true})
      this.renderer.setSize(container.clientWidth, container.clientHeight)
      this.renderer.shadowMap.enabled = true
      this.renderer.gammaOutput = true
      this.renderer.gammaFactor = 2.2
      container.appendChild(this.renderer.domElement)

      // scene
      this.scene = new Three.Scene()
      this.scene.background = new Three.Color(0xa0a0a0)

      // lighting
      this.directLight = new Three.DirectionalLight(0xffffff)
      this.directLight.position.set(0, 1000, 0)
      this.scene.add(this.directLight)

      this.camera = new Three.PerspectiveCamera(45, this.renderer.domElement.clientWidth / this.renderer.domElement.clientHeight, 1, 5000)
      this.camera.position.set(5, 965, 920)
      // this.camera.position.set(-500, 1000, -25)
      // this.camera.position.z = 1;

      // controls
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      this.controls.update()
      // this.controls.enabled = false

      this.transformControl = new TransformControls(this.camera, this.renderer.domElement)
      // this.transformControl.addEventListener( 'change', this.animate);
      this.transformControl.addEventListener('change', (e) => {
        let selectedModel = this.selectedModel
        if (this.selectedAnimation && this.selectedModel) {
          let normalizedPosition = selectedModel.position.toArray().map(pos => parseFloat((pos / positionOffset).toFixed(2)))
          let rotation = selectedModel.rotation.toArray()
          this.selectedAnimation.origin.position = normalizedPosition
          this.selectedAnimation.origin.rotation[0] = parseFloat((rotation[0] * radianUnit).toFixed(2))
          this.selectedAnimation.origin.rotation[1] = parseFloat((rotation[1] * radianUnit).toFixed(2))
          this.selectedAnimation.origin.rotation[2] = parseFloat((rotation[2] * radianUnit).toFixed(2))
          this.editor.signals.animationModified.dispatch(this.selectedAnimation)
        }
      })
      this.scene.add(this.transformControl)

      // loader
      // this.loader = new GLTFLoader()
      this.loader = new FBXLoader()

      this.raycaster = new Three.Raycaster()
      this.mouse = new Three.Vector2()

      // grid setting
      // this.grid = new Three.GridHelper(2000, 2000, 0x000000, 0x000000)
      new Three.TextureLoader().load('../static/files/targetImage.jpg', (texture) => {
        const material = new Three.MeshBasicMaterial({ map: texture, opacity: 1, side: Three.DoubleSide, transparent: true })
        const geometry = new Three.PlaneGeometry(1000, 775)
        const sprite = new Three.Mesh(geometry, material)
        sprite.rotateOnAxis(new Three.Vector3(1, 0, 0), Three.Math.degToRad(90))
        // sprite.rotateOnAxis(  new Three.Vector3( 0, 0, 0 ), Three.Math.degToRad(90) );
        this.scene.add(sprite)
      }, () => { console.log('loading texture') }, (e) => { console.error('error loading targetImage.jpg??', e) })

      // this.grid.material.opacity = 0.2
      // this.grid.material.transparent = true

      // this.scene.add(this.grid)

      container.addEventListener('click', this.canvasClick)
    },
    animationModified (selected) {
      if (selected === this.selectedAnimation && this.selectedModel) {
        this.selectedModel.position = new Three.Vector3(...selected.origin.position.map(pos => parseFloat((pos * positionOffset).toFixed(2))))

        // prevent model position from going below floor
        if (this.selectedModel.position.y < 0) {
          this.selectedModel.position.y = 0
        }
        let normalizedPosition = this.selectedModel.position.toArray().map(pos => parseFloat((pos / positionOffset).toFixed(2)))
        this.editor.signals.transferPostionToAnimation.dispatch(normalizedPosition)
        let x = selected.origin.rotation[0] / radianUnit
        let y = selected.origin.rotation[1] / radianUnit
        let z = selected.origin.rotation[2] / radianUnit
        this.selectedModel.rotation.set(x, y, z)
      }
    },
    canvasMouseMove (event) {
      event.preventDefault()

      // 'mouse' is of type Vector2

      this.mouse.x = (event.clientX / this.renderer.domElement.clientWidth) * 2 - 1
      this.mouse.y = -(event.clientY / this.renderer.domElement.clientHeight) * 2 + 1
    },
    canvasClick (event) {
      event.preventDefault()

      this.mouse.x = (event.clientX / this.renderer.domElement.clientWidth) * 2 - 1
      this.mouse.y = -(event.clientY / this.renderer.domElement.clientHeight) * 2 + 1
      this.raycaster.setFromCamera(this.mouse, this.camera)
      // See if the ray from the camera into the world hits one of our meshes

      // var intersects = this.raycaster.intersectObject(this.model)
      // Toggle rotation bool for meshes that we clicked
      // if (intersects.length > 0) {
      // }
    },
    animationAdded (element) {
      this.addModelToScene(element)
    },
    addModelToScene (element) {
      if (element.type === 'Character' && element.phase === 'assetSelected') {
        return this.getModelForElement(element).then(object => {
          // console.log(object.uuid)
          // object.uuid = Three.Math.generateUUID()
          // object = object.clone()

          // object.uuid = Three.Math.generateUUID()
          this.model = object
          this.model.name = element.id
          // this.model.scale = new Three.Vector3(0.009, 0.009, 0.009)
          this.model.position = new Three.Vector3(...element.origin.position.map(pos => parseFloat((pos * positionOffset).toFixed(2))))

          let x = element.origin.rotation[0] / radianUnit
          let y = element.origin.rotation[1] / radianUnit
          let z = element.origin.rotation[2] / radianUnit
          this.model.rotation.set(x, y, z)

          // this.model.scale.set(0.1, 0.1, 0.1)
          // this.model.rotation = new Three.Vector3( ...element.origin.rotation.map(val => val / radianUnit ) )
          this.scene.add(this.model)
          if (this.animationSelected) {
            this.selectAnimation(this.animationSelected)
          }
          this.model.traverse((object) => {
            if (object.isMesh) {
              object.castShadow = true
            }
          })
          return object
        }).catch(e => { console.error('there was a problem loading the model...', e) })
      } else if (element.type === 'Prop' && element.phase === 'assetSelected') {
        return this.getModelForElement(element).then(object => {
          this.model = object
          this.model.name = element.id
          // this.model.scale = new Three.Vector3(0.009, 0.009, 0.009)
          this.model.position = new Three.Vector3(...element.origin.position.map(pos => parseFloat((pos * positionOffset).toFixed(2))))
          this.model.rotation._x = element.origin.rotation[0] / radianUnit
          this.model.rotation._y = element.origin.rotation[1] / radianUnit
          this.model.rotation._z = element.origin.rotation[2] / radianUnit
          this.scene.add(this.model)
          if (this.animationSelected) {
            this.selectAnimation(this.animationSelected)
          }
          this.model.traverse((object) => {
            if (object.isMesh) {
              object.castShadow = true
            }
          })
          return object
        }).catch(e => {
          console.error('there was a problem loading the model...', e)
        })
      }
    },
    getModelForElement (element) {
      if (element.type === 'Character') {
        let fbxUrlPromise = this.modelUrlCache.get(element.value)
        if (!fbxUrlPromise) {
          let modelUrlPromise = this.getOriginalModelById(element.value)
          this.modelUrlCache.set(element.value, modelUrlPromise)
          fbxUrlPromise = modelUrlPromise
        }
        return fbxUrlPromise.then(fbxURL => {
          return new Promise((resolve, reject) => {
            this.loader.load(fbxURL, resolve)
          })
        })
      } else if (element.type === 'Prop') {
        let fbxUrlPromise = this.modelUrlCache.get(element.value)
        if (!fbxUrlPromise) {
          let modelUrlPromise = this.getPropById(element.value)
          this.modelUrlCache.set(element.value, modelUrlPromise)
          fbxUrlPromise = modelUrlPromise
        }
        return fbxUrlPromise.then(fbxURL => {
          return new Promise((resolve, reject) => {
            this.loader.load(fbxURL, resolve)
          })
        })
      }
    },
    animationPhaseChanged (element) {
      let addObjectPromise = this.addModelToScene(element)
      if (addObjectPromise) {
        addObjectPromise.then(object => {
          this.editor.signals.animationSelected.dispatch(element)
        })
      }
    },
    removeModelFromScene (element) {
      let child = this.scene.children.find(child => child.name === element.id)
      this.scene.remove(child)
    },
    animationRemoved (element) {
      this.removeModelFromScene(element)
    },
    playAnimation (selectedElement) {
      // this.mixers = []
      // this.transformControl.detach(this.model)
      this.getModelAnimationById(selectedElement.animation.animationId).then(fbxURL => {
        this.loader.load(fbxURL, (object) => {
          // this.scene.remove(this.model)

          // this.model = object
          // this.model.name = this.selectedAnimation.name
          // this.model.scale = new Three.Vector3(0.009, 0.009, 0.009)
          // this.model.position = new Three.Vector3( ...this.selectedAnimation.origin.position )
          // this.model.rotation = new Three.Vector3( ...this.selectedAnimation.origin.rotation.map(val => val / radianUnit ) )
          // this.scene.add(this.model)

          const mixer = new Three.AnimationMixer(this.selectedModel)
          const clip = Three.AnimationClip.findByName(object.animations, 'mixamo.com')
          const animation = mixer.clipAction(clip)
          animation.setLoop(Three.LoopOnce)
          animation.play()
          this.mixers.push(mixer)
          // this.transformControl.attach(this.model);
          // this.model.traverse((object) => {
          //   if (object.isMesh) {
          //     object.castShadow = true
          //   }
          // })
        }, () => { console.log('') }, (e) => { })
      })
    },
    animate () {
      this.id = requestAnimationFrame(this.animate)
        // this.transformControl.update();
        // this.renderer.setSize(container.clientWidth, container.clientHeight);
      this.onWindowResize()
      if (this.mixers.length > 0) {
        let delta = this.clock.getDelta()
        for (let i = 0; i < this.mixers.length; i++) {
          this.mixers[i].update(delta)
        }
      }
      this.renderer.render(this.scene, this.camera)
    },
    onWindowResize () {
      const canvas = this.renderer.domElement
      const container = this.$refs.mycanvas
      if (container && (canvas.width !== container.clientWidth || canvas.height !== container.clientHeight)) {
        this.camera.aspect = container.clientWidth / container.clientHeight
        this.camera.updateProjectionMatrix()
        this.renderer.setSize(container.clientWidth, container.clientHeight)
      }
    },
    displayTimelineElements () {
      if (this.selectedTimeline && this.selectedTimeline.elements.length) {
        this.selectedTimeline.elements.forEach(element => {
          let childInScene = this.scene.children.find(child => child.name === element.id)
          if (!childInScene && element.type === 'Character' && element.phase === 'assetSelected') {
            this.animationAdded(element)
          } else if (!childInScene && element.type === 'Prop' && element.phase === 'assetSelected') {
            this.animationAdded(element)
          }
        })
      }
    }
  },
  mounted () {
    // this is temporary as the animation is not rendering due to vuetify transition issue -dj
    // setTimeout(() => {
    //   this.init();
    //   this.animate();
    //   console.log('called render')
    // }, 5000)
    this.init()
    this.animate()
    document.addEventListener('keydown', this.keyDownEvent)
    this.editor.signals.playAnimation.add(this.playAnimation)
    this.editor.signals.animationAdded.add(this.animationAdded)
    this.editor.signals.animationPhaseChanged.add(this.animationPhaseChanged)
    this.editor.signals.animationRemoved.add(this.animationRemoved)
    this.editor.signals.animationModified.add(this.animationModified)
    this.editor.signals.animationSelected.add(this.selectAnimation)
    window.addEventListener('resize', this.onWindowResize, false)
    this.displayTimelineElements()
  },
  destroyed () {
    if (this.id) {
      cancelAnimationFrame(this.id)
    }
  }
}
</script>

<style scoped>
   #mycanvas {
     /* width: 300px;
     height: 250px; */

     /* position: absolute; */
     /* top: 0;
     right: 0; */
     z-index: 4;
   }

   #mycanvas-controls {
     position: absolute;
   }
</style>



// WEBPACK FOOTER //
// src/components/story-edit-view/preview.vue